import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, merge, startWith, Subject, switchMap } from 'rxjs';
import { ContactGrouopService } from 'src/app/private/services/contact-groups.service';
import { SubscriptionService } from 'src/app/private/services/subscription.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CountryISO } from 'ngx-intl-tel-input';
import { assignIntlPhone, phoneControlValue, regionForDialCode } from 'src/app/utils/phone-country.util';
@Component({
  selector: 'app-contact-group-list',
  templateUrl: './contact-group-list.component.html',
  styleUrls: ['./contact-group-list.component.scss']
})
export class ContactGroupListComponent {

 
  contactForm!: FormGroup;
  pageSizeOptions: number[] = [10, 25, 100];
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;
  searchQuery = new FormControl();
  dateQuery = new FormControl();
  btnLoading = false;
  initialLoad2 = true;
  // isRefresh = false;
  @Input() isRefresh: any;
  formAction: string = 'Create';
  phoneCountryIso: CountryISO = '' as CountryISO;

  private readonly baseColumns: string[] = [
    "name",
    "source",
    "email",
    "phone",
    "action"
  ];
  displayedColumns: string[] = [...this.baseColumns];
  whatsappStatusFilter: 'all' | 'no' = 'all';
  selectedRows: Record<string, boolean> = {};
  bulkDeleteMode: 'selected' | 'all' = 'selected';
  private readonly listRefresh = new Subject<void>();


  @Input() currentSelectedContactGroupID: any;
  selectedContactId: any;
  @Input() GroupListData: any;
  @Input() currentPage: any;
  @Input() pageSize: any;
  @Input() totalRows: any;
  @Input() dataSource: any;
  @Input() initialLoad: any;
  formSubmitted = false;
  whatsappPreview: any = null;
  whatsappResult: any = null;
  whatsappStep: 'confirm' | 'results' = 'confirm';
  recheckWhatsapp = false;
  whatsappPreviewLoading = false;
  whatsappCheckLoading = false;
  whatsappDeleteLoading = false;
  notOnWhatsappSelection: Record<string, boolean> = {};
  packageHasWhatsappCheck = false;
  private readonly whatsappFeatureKeys = ['whatsapp_number_check_credits'];
@ViewChild('contact_form') contactFormModal!: TemplateRef<any>;
  constructor(
    private toast: ToastrService,
    private api: ContactGrouopService,
    private modalService: NgbModal,
    private localStorage: LocalStorageService,
    private subscriptionService: SubscriptionService,
    private fb: FormBuilder
  ) {

  }


  get canCheckWhatsapp(): boolean {
    return this.packageHasWhatsappCheck;
  }

  get selectedNonWhatsappCount(): number {
    return Object.values(this.notOnWhatsappSelection).filter(Boolean).length;
  }

  get selectedRowCount(): number {
    return Object.values(this.selectedRows).filter(Boolean).length;
  }

  get pageRows(): any[] {
    return this.dataSource?.data || [];
  }

  ngOnInit() {
    this.loadWhatsappFeatureAccess();
  }

  ngAfterViewInit() {
    this.loadData();
    this.initContactForm();
  }

  private loadWhatsappFeatureAccess() {
    const clientId = this.localStorage.getClientId();
    if (!clientId) return;
    this.subscriptionService
      .getCurrentUserActivePackage({ client_id: clientId }, { forceRefresh: true })
      .subscribe({
      next: (res: any) => {
        const usage = res?.data?.usage || res?.usage || [];
        this.packageHasWhatsappCheck = usage.some((item: any) =>
          this.whatsappFeatureKeys.includes(String(item?.feature_key || '').toLowerCase())
        );
      },
      error: () => {
        this.packageHasWhatsappCheck = false;
      },
    });
  }

  openWhatsappCheck(modal: TemplateRef<any>) {
    if (!this.currentSelectedContactGroupID) {
      this.toast.error('Select a contact group first.');
      return;
    }
    this.recheckWhatsapp = false;
    this.whatsappStep = 'confirm';
    this.whatsappPreview = null;
    this.whatsappResult = null;
    this.notOnWhatsappSelection = {};
    this.modalService.open(modal, { centered: true, backdrop: 'static' });
    this.loadWhatsappPreview();
  }

  onRecheckToggle(checked: boolean) {
    this.recheckWhatsapp = checked;
    this.loadWhatsappPreview();
  }

  loadWhatsappPreview() {
    this.whatsappPreviewLoading = true;
    this.api.previewWhatsappNumberCheck(this.whatsappPayload()).subscribe({
      next: (res: any) => {
        this.whatsappPreview = res;
        this.whatsappPreviewLoading = false;
      },
      error: (error: any) => {
        this.whatsappPreviewLoading = false;
        this.toast.error(this.apiMessage(error, 'Could not preview the WhatsApp check.'));
      },
    });
  }

  runWhatsappCheck() {
    if (!this.whatsappPreview?.can_check || this.whatsappCheckLoading) return;
    this.whatsappCheckLoading = true;
    this.api.checkWhatsappNumbers(this.whatsappPayload()).subscribe({
      next: (res: any) => {
        this.whatsappResult = res;
        this.notOnWhatsappSelection = {};
        (res?.not_on_whatsapp || []).forEach((contact: any) => {
          this.notOnWhatsappSelection[String(contact.id)] = false;
        });
        this.whatsappStep = 'results';
        this.whatsappCheckLoading = false;
        if (res?.warning) this.toast.warning(res.warning);
        this.loadData();
      },
      error: (error: any) => {
        this.whatsappCheckLoading = false;
        this.toast.error(this.apiMessage(error, 'WhatsApp check failed.'));
      },
    });
  }

  toggleNonWhatsapp(id: any, checked: boolean) {
    this.notOnWhatsappSelection[String(id)] = checked;
  }

  toggleAllNonWhatsapp(checked: boolean) {
    (this.whatsappResult?.not_on_whatsapp || []).forEach((contact: any) => {
      this.notOnWhatsappSelection[String(contact.id)] = checked;
    });
  }

  allNonWhatsappSelected(): boolean {
    const rows = this.whatsappResult?.not_on_whatsapp || [];
    return rows.length > 0 && rows.every((contact: any) => this.notOnWhatsappSelection[String(contact.id)]);
  }

  deleteNonWhatsappContacts() {
    const ids = Object.keys(this.notOnWhatsappSelection)
      .filter((id) => this.notOnWhatsappSelection[id])
      .map((id) => Number(id));
    if (!ids.length || this.whatsappDeleteLoading) return;

    this.whatsappDeleteLoading = true;
    this.api.deleteNonWhatsappContacts({
      ...this.whatsappPayload(),
      ids,
    }).subscribe({
      next: (res: any) => {
        const removed = new Set((res?.deleted_ids || ids).map((id: any) => Number(id)));
        this.whatsappResult.not_on_whatsapp = (this.whatsappResult.not_on_whatsapp || [])
          .filter((contact: any) => !removed.has(Number(contact.id)));
        this.whatsappResult.not_on_whatsapp_count = this.whatsappResult.not_on_whatsapp.length;
        this.notOnWhatsappSelection = {};
        this.whatsappDeleteLoading = false;
        this.toast.success(`${res?.deleted_count || ids.length} contact(s) deleted.`);
        this.loadData();
      },
      error: (error: any) => {
        this.whatsappDeleteLoading = false;
        this.toast.error(this.apiMessage(error, 'Could not delete those contacts.'));
      },
    });
  }

  creditLabel(value: any): string {
    if (value === -1) return 'Unlimited';
    if (value == null) return 'Not configured';
    return String(value);
  }

  private whatsappPayload() {
    return {
      client_id: this.localStorage.getClientId(),
      contact_group_id: this.currentSelectedContactGroupID,
      recheck: this.recheckWhatsapp,
    };
  }

  onWhatsappFilterChange(value: 'all' | 'no') {
    this.whatsappStatusFilter = value;
    this.selectedRows = {};
    this.displayedColumns = value === 'no' ? ['select', ...this.baseColumns] : [...this.baseColumns];
    if (this.paginator) this.paginator.pageIndex = 0;
    this.listRefresh.next();
  }

  toggleRow(id: any, checked: boolean) {
    this.selectedRows[String(id)] = checked;
  }

  togglePageRows(checked: boolean) {
    this.pageRows.forEach((row) => {
      this.selectedRows[String(row.id)] = checked;
    });
  }

  allPageRowsSelected(): boolean {
    return this.pageRows.length > 0 && this.pageRows.every((row) => this.selectedRows[String(row.id)]);
  }

  openBulkDelete(modal: TemplateRef<any>, mode: 'selected' | 'all') {
    if (mode === 'selected' && !this.selectedRowCount) return;
    if (mode === 'all' && !this.totalRows) return;
    this.bulkDeleteMode = mode;
    this.modalService.open(modal, { centered: true, backdrop: 'static' });
  }

  confirmBulkDelete() {
    const deleteAll = this.bulkDeleteMode === 'all';
    const ids = Object.keys(this.selectedRows)
      .filter((id) => this.selectedRows[id])
      .map((id) => Number(id));
    if ((!deleteAll && !ids.length) || this.whatsappDeleteLoading) return;

    this.whatsappDeleteLoading = true;
    this.api.deleteNonWhatsappContacts({
      ...this.whatsappPayload(),
      ids,
      delete_all: deleteAll,
    }).subscribe({
      next: (res: any) => {
        this.whatsappDeleteLoading = false;
        this.selectedRows = {};
        this.modalService.dismissAll();
        this.toast.success(`${res?.deleted_count || 0} contact(s) deleted.`);
        this.listRefresh.next();
      },
      error: (error: any) => {
        this.whatsappDeleteLoading = false;
        this.toast.error(this.apiMessage(error, 'Could not delete those contacts.'));
      },
    });
  }

  private apiMessage(error: any, fallback: string): string {
    const body = error?.error;
    if (typeof body === 'string' && body.trim()) return body;
    return body?.message || body?.msg || fallback;
  }

  initContactForm() {
  this.contactForm = this.fb.group({
    id: [null],
    name: ['', Validators.required],
    source: [''],
    email: ['', [Validators.required, Validators.email]],
    phone: ['', [Validators.required]]
  });
}

  deleteContactData() {

    this.btnLoading = true;
    const payload = {
      id: this.selectedContactId.id,
      contact_group_id: this.currentSelectedContactGroupID,
      client_id: this.localStorage.getClientId()
    };  
    this.api.deleteGroupListContact(payload).subscribe(
      {
        next: (res: any) => {   
          this.toast.success('Group Contact deleted successfully');
          this.btnLoading = false;
          this.modalService.dismissAll();
          this.loadData();
        },
        error: (error: any) => {
          console.error('Error deleting group contact:', error);
          this.toast.error('Failed to delete group contact . Please try again.');
          this.modalService.dismissAll();
          this.btnLoading = false;
        }
      }
    );
  }
  fn_deleteContact(deleteContact: any, element: any) {
    this.selectedContactId = element;
    this.modalService.open(deleteContact, { centered: true });
  } 

  editContact(element: any,model: any) {
    this.selectedContactId = element;
     this.formAction = 'Edit';
      this.phoneCountryIso = regionForDialCode(element.country_code);
      this.contactForm.patchValue({
        id: this.selectedContactId.id,
        name: this.selectedContactId.name,
        source: this.selectedContactId.source,
        email: this.selectedContactId.email,
        phone: phoneControlValue(element.country_code, element.phone)
      });
    this.modalService.open(model, { centered: true });
  }

  openAddContact() {
  this.modalService.open(this.contactFormModal, { centered: true });  
  this.formAction = 'Add';
  this.phoneCountryIso = '' as CountryISO;
  this.contactForm.reset({
    id: null,
    name: '',
    source: '',
    email: '',
    phone: ''
  });
}
saveContact() {
  this.formSubmitted = true;
  console.log("Saving contact...",this.contactForm.invalid);

  if (this.contactForm.invalid) {
    this.contactForm.markAllAsTouched();
    return;
  }

  this.btnLoading = true;
  const phoneTarget: any = {};
  assignIntlPhone(phoneTarget, 'phone', this.contactForm.value.phone);

  const payload: any = {
    ...this.contactForm.value,
    contact_group_id: this.currentSelectedContactGroupID,
    client_id: this.localStorage.getClientId(),
    source: this.contactForm.value.source || 'manual',
    ...(phoneTarget.phone
      ? { phone: phoneTarget.phone, country_code: phoneTarget.country_code }
      : {}),
  };


  if (payload.id) {
    payload.id = payload.id;
    // Update
    this.api.updateContactGroupList(payload).subscribe({
      next: () => {
        this.toast.success('Contact updated successfully');
        this.btnLoading = false;
        this.modalService.dismissAll();
        this.loadData();
        // this.ds.close();
        // this.loadContacts();
      },
      error: (error) => {
        const message = error?.error?.message || error?.error?.errors?.[0]?.message;
        this.toast.error(message || 'Failed to update contact');
        this.btnLoading = false;
      }
    });

  } else {
    delete payload.id;

    let mappedData = [];
    mappedData.push({
      name: payload.name,
      source: payload.source || 'manual',
      email: payload.email,
      phone: payload.phone,
      country_code: payload.country_code
    });

   const finalData = {
      client_id: this.localStorage.getClientId(),
      contact_group_id: this.currentSelectedContactGroupID,
      contacts: mappedData
    };
  
    // Add
    this.api.addGroupListContact(finalData).subscribe({
      next: () => {
        this.toast.success('Contact added successfully');
        this.btnLoading = false;
        this.modalService.dismissAll();
        this.loadData();
        // this.modalRef.close();
        // this.loadContacts();
      },
      error: (error) => {
        const message = error?.error?.message || error?.error?.errors?.[0]?.message;
        this.toast.error(message || 'Failed to add contact');
        this.btnLoading = false;
      }
    });
  }
}

  loadData(type?: string) {


    try {
      // this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
      merge(
        this.dateQuery.valueChanges,
        this.searchQuery.valueChanges,
        this.sort.sortChange,
        this.paginator.page,
        this.listRefresh
      )
        .pipe(
          startWith({}),
          switchMap(() => {

    this.isRefresh = true;
            
            console.log("client_id", this.localStorage.getClientId())
          
            const where: any = {
              client_id: this.localStorage.getClientId(),
              contact_group_id: this.currentSelectedContactGroupID,
            };
            if (this.whatsappStatusFilter === 'no') where.whatsapp_status = 'no';
            const payload = {
              "where": where,
              "filter": null,
              "page": this.paginator.pageIndex * this.paginator.pageSize,
              "limit": this.paginator.pageSize,
              "order": {
                  "col": "\"contact_group_list\".\"createdAt\"",
                  "dir": "DESC"
              }
          }
        

            return this.api
              .getAllContactGroupList(payload)
              .pipe(catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            this.isRefresh = false;
            return response.rows;
          })
        )
        .subscribe({
          next: (data) => {
          
            this.initialLoad2 = false;

            if(this.initialLoad === true){
              return;
            }
            this.dataSource = new MatTableDataSource<any>(data);

            this.GroupListData = data;

           this.isRefresh = false;
          },
          error: (e) => {
            this.initialLoad = false;
           this.isRefresh = false;

            console.error(e);
          },
          complete: () => {
          },
        });
    } catch (e) {
      console.error(e);
    }
  }

  resetPaginator() {
    if (this.paginator) {
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 10; // Set default pageSize or any value you want
    }
  }

}


function observableOf(arg0: null): any {
  console.log(arg0);
  throw new Error('Function not implemented.');
}